import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./Bill.css";

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "N/A";

const Bill = ({ order, onClose }) => {
  if (!order) return null;

  const validTotal = order.products
    .filter((p) => p.status !== "Cancelled")
    .reduce((sum, p) => sum + p.price * p.quantity, 0);

  const isCompleted = order.status === "Completed";

  const downloadPDF = () => {
    const doc = new jsPDF();

    // ===== TITLE =====
    doc.setFontSize(18);
    doc.text("INVOICE / BILL", 14, 20);

    // ===== CUSTOMER DETAILS =====
    doc.setFontSize(11);
    doc.text(`Customer: ${order.customer?.name}`, 14, 35);
    doc.text(`Mobile: ${order.customer?.phone}`, 14, 42);
    doc.text(`Address: ${order.customer?.address}`, 14, 49);
    doc.text(`Order ID: #${order._id.slice(-6)}`, 14, 56);
    doc.text(`Order Date: ${formatDate(order.createdAt)}`, 14, 63);

    // ✅ Completed → "Delivered", Placed → "Expected Delivery"
    doc.text(
      `${isCompleted ? "Delivered" : "Expected Delivery"}: ${formatDate(order.deliveryDate)}`,
      14,
      70
    );

    // ===== TABLE =====
    const tableData = order.products.map((p) => [
      p.name,
      `${p.quantity} ${p.unit}`,
      p.status === "Cancelled" ? "Rs. 0" : `Rs. ${p.price * p.quantity}`,
      p.status === "Cancelled" ? "Cancelled" : "OK",
    ]);

    autoTable(doc, {
      startY: 78,
      head: [["Item", "Quantity", "Amount", "Status"]],
      body: tableData,
      styles: { fontSize: 10 },
    });

    // ===== TOTAL =====
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(14);
    doc.text(`Total Amount: Rs. ${validTotal}`, 14, finalY);

    // ===== SAVE =====
    doc.save(`Invoice_${order._id.slice(-6)}.pdf`);
  };

  return (
    <div className="bill-overlay">
      <div className="bill-box">
        <h2>🧾 Invoice</h2>

        <div className="bill-section">
          <p><b>Name:</b> {order.customer?.name}</p>
          <p><b>Phone:</b> {order.customer?.phone}</p>
          <p><b>Address:</b> {order.customer?.address}</p>
          <p><b>Order ID:</b> #{order._id.slice(-6)}</p>
          <p><b>📅 Order Date:</b> {formatDate(order.createdAt)}</p>

          {/* ✅ Status ke hisaab se label change hoga */}
          <p>
            <b>{isCompleted ? "✅ Delivered:" : "🚚 Expected Delivery:"}</b>{" "}
            <span className={order.deliveryDate ? "date-green" : "date-red"}>
              {formatDate(order.deliveryDate)}
            </span>
          </p>
        </div>

        {/* Products */}
        <div className="bill-products">
          {order.products.map((p, i) => (
            <div key={i} className="bill-row">
              <span>{p.name} ({p.quantity} {p.unit})</span>
              <span>
                {p.status === "Cancelled" ? (
                  <span className="date-red">Cancelled</span>
                ) : (
                  `Rs. ${p.price * p.quantity}`
                )}
              </span>
            </div>
          ))}
        </div>

        <div className="bill-total">
          <h3>Total: Rs. {validTotal}</h3>
        </div>

        <div className="bill-actions">
          <button onClick={downloadPDF}>⬇ Download PDF</button>
          <button className="close-btn" onClick={onClose}>❌ Close</button>
        </div>
      </div>
    </div>
  );
};

export default Bill;